<template>
  <div v-if="loading || this.report.length !== 0">
    <states-map
      :report="report">
    </states-map>
    <report-table
      :report="report" 
      :stats="processedOptions.stats" 
      :fields="processedOptions.fields"
      :current-page="currentPage"
      :per-page="perPage"
      :synced-with-graph="true">
    </report-table>
    <hr class="m-0 border-border" />
    <b-pagination 
      v-if="perPage > 0 && report.length > 0" 
      class="mt-3"
      :total-rows="report.length" 
      align="center" 
      v-model="currentPage"
      :per-page="perPage">
    </b-pagination>
  </div>
  <no-results v-else></no-results>
</template>

<script>
import { reportView } from '@/reports/components/mixins/reportView'
import ReportTable from '@/reports/components/ReportTable'
import StatesMap from '@/reports/components/maps/StatesMap'
import NoResults from '@/components/NoResults'

export default {
  name: 'StatesView',
  data () {
    return {
      perPage: 10,
      currentPage: 1
    }
  },
  methods: {
    processOptions (oldOptions) {
      let options = JSON.parse(JSON.stringify(oldOptions))
      options.fields.push('geo_region')
      options.filters.push({ field: 'geo_country', operator: 'EQUAL', value: 'USA' })
      options.stats.push('unique_users')
      options.stats.push('bids')
      return options
    }
  },
  created () {
    console.log('usa usa usa')
  },
  mixins: [
    reportView
  ],
  components: {
    ReportTable,
    StatesMap,
    NoResults
  }
}
</script>


// WEBPACK FOOTER //
// src/reports/components/maps/StatesView.vue